import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useParams, useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Button from "sushiweb/Button";
import Tooltip from "sushiweb/Tooltip";
import ErrorMsgs from "../../constants/Errors.json";
import Plus from "sushiweb/Icons/all/Plus";
import Gear from "sushiweb/Icons/all/Gear";
import CheckCircleFill from "sushiweb/Icons/all/CheckCircle";
import commonStyles from "../../static/styles/common";
import Level from "../../components/GenSetting/Level";
import OrderFormModal from "../../components/GenSetting/OrderFormModal";
import RuleFormModal from "../../components/GenSetting/AddRuleFormModal";
import GenSettingList from "../../components/GenSetting/GenSettingList";
import * as GenSettingActions from "../../store/actions/GenSetting";
import * as CityPropertyActions from "../../store/actions/CityProperty";
import * as CityActions from "../../store/actions/City";
import * as UserActions from "../../store/actions/User";
import Permission from "../../components/Common/Permission";
import MenuNames from "../../constants/Menu/MenuNames.json";
import MenuActionsMappings from "../../constants/Menu/MenuActionsMappings";
import { isEmpty } from "../../utils/index";
import InfiniteScrollDropdown from "../../components/Common/InfiniteScrollDropdown";
import OrderHistory from "sushiweb/Icons/all/OrderHistory";

const useStyles = makeStyles((theme) => ({
  ...commonStyles.tableListStyles,
  Container: {
    height: "auto",
    overflowY: "scroll",
  },
  button: {
    margin: theme.spacing(1),
    class: "shushi-btn",
    width: "12.5rem",
    height: "2.75rem",
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 150,
  },
  fieldsMargin: {
    margin: "0",
    width: 250,
  },
  toolTip: {
    marginTop: "2.5rem",
  },
}));

const deleteCol = ["is_city_property", "is_modified", "is_new"];

const GenSetting = (props) => {
  const classes = useStyles();
  const history = useHistory();
  const [label, setLabel] = useState("");
  const { id } = useParams();
  const [modalState, setModalState] = useState(false);
  const allActions = MenuActionsMappings[MenuNames.CONFIG];
  const {
    activeGenSetting,
    activeCityProperty,
    finalConfig,
    activeRule,
    level,
    allMenuActions,
  } = props;
  const [isCitySelected, setSelectedCity] = useState(false);
  useEffect(() => {
    props.getFormschema();
  }, []);

  useEffect(() => {
    if (id) {
      props.resetStateGenSetting({ state: "activeRule" });
      props
        .getCityProperty(parseInt(id))
        .then((CityPropObj) => {
          props
            .getGenSettingRule()
            .then((GenSettingObj) => {
              props
                .getFinalConfig(CityPropObj, GenSettingObj)
                .then((finalConfigObj) => {
                  props.setFinalConfig(finalConfigObj);
                  setSelectedCity(true);
                  setLabel(CityPropObj.city_name);
                })
                .catch((err) => {
                  props.setStatus({
                    type: "error",
                    message:
                      typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
                  });
                });
            })
            .catch((err) => {
              props.setStatus({
                type: "error",
                message:
                  typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
              });
            });
        })
        .catch((err) => {
          props.setStatus({
            type: "error",
            message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
          });
        });
    } else {
      props.resetStateGenSetting({ state: "activeRule" });
      props.resetStateCityProperty({ state: "activeCityProperty" });
      props
        .getGenSettingRule()
        .then((GenSettingObj) => {
          props
            .getFinalConfig({}, GenSettingObj)
            .then((finalConfigObj) => {
              props.setFinalConfig(finalConfigObj);
              setSelectedCity(false);
              setLabel("General Setting");
            })
            .catch((err) => {
              props.setStatus({
                type: "error",
                message:
                  typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
              });
            });
        })
        .catch((err) => {
          props.setStatus({
            type: "error",
            message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
          });
        });
    }
  }, []);

  const takemetologs = () => {
    if (id) {
      history.push(`/city-property/change-logs/${id}`);
    } else {
      history.push(`/gen-setting/change-logs`);
    }
  };

  const handlselectChange = (key, id) => {
    if (id === "") {
      history.push("/relaxation-configuration/gen-setting");
    } else {
      history.push(`/relaxation-configuration/city-property/${id}`);
    }
  };

  const handleSave = () => {
    //if a city is selected then save the rule inside city property
    var cityProperty = {};
    if (isCitySelected) {
      if (!isEmpty(activeRule)) {
        try {
          if (activeCityProperty.value.rules !== undefined) {
            activeCityProperty.value.rules.push(activeRule);
          } else {
            var newRuleArray = [activeRule];
            activeCityProperty.value.rules = newRuleArray;
          }
          props.resetStateGenSetting({ state: "activeRule" });
        } catch (error) {
          props.setStatus({
            type: "error",
            message:
              typeof error === "string" ? error : ErrorMsgs.GENERAL_ERROR_1,
          });
        }
      }
      //delete Ui only columns before writing to db
      if (activeCityProperty.value.rules !== undefined) {
        activeCityProperty.value.rules.map((rule) => {
          deleteCol.forEach((field) => {
            if (rule[field] !== undefined) {
              delete rule[field];
            }
          });
          return rule;
        });
      }
    }
    //if city is not selected and a activeRule exists then add it in general setting rules to update it
    if (!isEmpty(activeRule) && !isCitySelected) {
      try {
        activeGenSetting.value.rules.push(activeRule);
        props.resetStateGenSetting({ state: "activeRule" });
      } catch (error) {
        props.setStatus({
          type: "error",
          message:
            typeof error === "string" ? error : ErrorMsgs.GENERAL_ERROR_1,
        });
      }
    }
    //delete Ui only columns before writing to db
    activeGenSetting.value.rules.map((rule) => {
      deleteCol.forEach((field) => {
        if (rule[field] !== undefined) {
          delete rule[field];
        }
      });
      return rule;
    });
    if (isCitySelected) {
      if (isEmpty(activeCityProperty.value)) {
        activeCityProperty.value = { rules: [] };
      }
      props
        .updateCityProperty(activeCityProperty.id, activeCityProperty)
        .then((CityPropObj) => {
          props.setActiveCityProperty(CityPropObj);
          props
            .getFinalConfig(CityPropObj, activeGenSetting)
            .then((finalConfigObj) => {
              props.setFinalConfig(finalConfigObj);
            });
        });
    } else {
      props.updateGenSetting(activeGenSetting).then((GenSettingObj) => {
        props.setActiveGenSetting(GenSettingObj);
        props
          .getFinalConfig(cityProperty, GenSettingObj)
          .then((finalConfigObj) => {
            props.setFinalConfig(finalConfigObj);
          });
      });
    }
  };

  const checkIfDisabled = () => {
    return (
      allMenuActions[allActions.GEN_SETTING_UPDATE] &&
      allMenuActions[allActions.CITY_PROPERTY_UPDATE]
    );
  };

  const handleClick = (type) => {
    setModalState(type);
  };

  const handleClose = () => {
    setModalState(false);
  };

  const getLevel = () => {
    return <Level />;
  };

  const getModal = () => {
    const OrderProps = {
      modalState: modalState,
      handleClose: handleClose,
      activeGenSetting: activeGenSetting,
    };

    const RuleProps = {
      modalState: modalState,
      activeCityProperty: activeCityProperty,
      activeGenSetting: activeGenSetting,
      handleClose: handleClose,
      finalConfig: finalConfig,
    };

    switch (modalState) {
      case "simulate":
        return <OrderFormModal className="RuleFormModal" {...OrderProps} />;
      case "addRule":
        return <RuleFormModal {...RuleProps}></RuleFormModal>;
      default:
        return;
    }
  };

  return (
    <GeneralSettingSection className="GeneralSetting-View container">
      <div className="GenSetting-Tab flex mb-20 items-center justify-between">
        <Permission
          requiredPerms={[
            allActions.GET_FINAL_CONFIG,
            allActions.GET_LEVEL,
            allActions.GET_SCHEMA,
          ]}
        >
          <div className="city-dropdown">
            <FormControl
              className={classes.fieldsMargin}
              variant="outlined"
              component="div"
              margin="dense"
            >
              <InfiniteScrollDropdown
                priorityFlag={1}
                id="CpCityDropdown"
                getActiveList={props.getCityList}
                nextPage={props.nextPageCity}
                resKey="cities"
                keyName="city_id"
                labelKey="city_name"
                getDataLabelKey="city.city_name"
                keyTypeToSet="id"
                label={label}
                handleChange={handlselectChange}
                remoteSearchApplicable={true}
                appliedFilters={{}}
                remoteSearchKey="startswith"
              />
            </FormControl>
          </div>
          <div style={{ marginLeft: "auto", marginRight: "0rem" }}>
            <Button
              onClick={() => takemetologs()}
              className="sushi-btn ml-16"
              icon={<OrderHistory />}
              id="changelogsbutton"
            >
              <b>Change Logs</b>
            </Button>
            <Tooltip
              label={
                !isEmpty(activeRule)
                  ? "Please either SAVE or DELETE the newly created Rule before creating another!!"
                  : ""
              }
              position="left"
              widthMaxContent={true}
              appearance="light"
              className={classes.toolTip}
            >
              <Button
                onClick={() => handleClick("addRule")}
                icon={<Plus />}
                className="sushi-btn ml-16"
                disabled={!isEmpty(activeRule)}
                data-testid="addRule"
              >
                <b>Add Rule</b>
              </Button>
            </Tooltip>
            <Button
              onClick={() => handleClick("simulate")}
              icon={<Gear />}
              className="sushi-btn ml-16"
              disabled={!finalConfig.length}
              data-testid="simulate"
            >
              <b>Simulate</b>
            </Button>
            <Button
              onClick={() => handleSave()}
              icon={<CheckCircleFill />}
              className="sushi-btn ml-16"
              data-testid="save"
              disabled={!checkIfDisabled()}
            >
              <b>Save</b>
            </Button>
          </div>
        </Permission>
      </div>
      <Permission
        requiredPerms={[
          allActions.GET_GEN_SETTING,
          allActions.GET_FINAL_CONFIG,
          allActions.GET_CITY_PROPERTY,
        ]}
      >
        <GenSettingList
          isCitySelected={isCitySelected}
          setSelectedCity={setSelectedCity}
          handleClick={handleClick}
        />
      </Permission>
      {level !== undefined && !isEmpty(level) && getLevel()}
      {!!modalState && getModal()}
    </GeneralSettingSection>
  );
};

const GeneralSettingSection = styled.section`
  .city-dropdown {
    .MuiAutocomplete-root {
      margin-bottom: unset !important;
    }
  }
`;

const mapStateToProps = (state) => {
  const { GenSetting, CityProperty, Level, City, MenuActions } = state;
  return {
    ruleSchema: GenSetting.ruleSchema,
    activeGenSetting: GenSetting.activeGenSetting,
    activeCityProperty: CityProperty.activeCityProperty,
    finalConfig: GenSetting.finalConfig,
    activeRule: GenSetting.activeRule,
    level: Level.level,
    createdRule: GenSetting.activeRule,
    nextPageCity: City.nextPage,
    allMenuActions: MenuActions.allMenuActions,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCityList: bindActionCreators(CityActions.getCityList, dispatch),
    getFormschema: bindActionCreators(
      GenSettingActions.getFormSchema,
      dispatch
    ),
    getGenSettingRule: bindActionCreators(
      GenSettingActions.getGenSettingRule,
      dispatch
    ),
    updateGenSetting: bindActionCreators(
      GenSettingActions.updateGenSetting,
      dispatch
    ),
    setActiveGenSetting: bindActionCreators(
      GenSettingActions.setActiveGenSetting,
      dispatch
    ),
    getFinalConfig: bindActionCreators(
      GenSettingActions.getFinalConfig,
      dispatch
    ),
    resetStateGenSetting: bindActionCreators(
      GenSettingActions.resetState,
      dispatch
    ),
    setFinalConfig: bindActionCreators(
      GenSettingActions.setFinalConfig,
      dispatch
    ),
    getCityProperty: bindActionCreators(
      CityPropertyActions.getCityProperty,
      dispatch
    ),
    resetStateCityProperty: bindActionCreators(
      CityPropertyActions.resetState,
      dispatch
    ),
    updateCityProperty: bindActionCreators(
      CityPropertyActions.updateCityProperty,
      dispatch
    ),
    setActiveCityProperty: bindActionCreators(
      CityPropertyActions.setActiveCityProperty,
      dispatch
    ),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GenSetting);
